module.exports = __webpack_public_path__ + "img/48C381_226640_369F64_3CAC74-256px.0aa1a10a.png";